module.exports = __webpack_public_path__ + "static/media/giftsReceived_75_100.aed7b625.png";